import { useNavigate } from "react-router-dom";
import logoImage from "../../assets/logo-black.png";
import { useEffect, useRef, useState } from "react";
import dotsIcon from "../../assets/icons/navbar/vertical-dots.svg";
import logoutIcon from "../../assets/icons/navbar/logout.svg";

const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const name = localStorage.getItem("name");
  const profilePic = localStorage.getItem("profile_picture");
  const defaultProfile =
    "https://requal.s3.ap-south-1.amazonaws.com/architect/06a8474d-b3c2-41dd-9b07-8c999db0e51d.svg";
  return (
    <nav className="bg-background shadow-custom-soft rounded-lg text-darkText p-3 px-5 w-full">
      <div className="flex justify-between items-center relative">
        <h1 className="uppercase font-fw_600">
          <img src={logoImage} width={94} height={24} />
        </h1>
        <div>
          <div className="flex gap-4 items-center">
            <div className="flex gap-2 items-center">
              <div className="w-[30px] h-[30px] rounded-full">
                {profilePic ? (
                  <img
                    src={profilePic}
                    alt="profile"
                    className="w-full h-full rounded-full"
                  />
                ) : (
                  <img
                    src={defaultProfile}
                    alt="profile"
                    className="w-full h-full rounded-full"
                  />
                )}
              </div>
              <p className="text-fs_16 font-fw_500">{name}</p>
            </div>

            <img
              src={dotsIcon}
              alt=":"
              width={18}
              height={18}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="cursor-pointer"
            />
          </div>

          {dropdownOpen && (
            <div
              ref={dropdownRef}
              className="absolute top-10 right-0 bg-white shadow-md rounded-md flex gap-2 p-2 z-[55505050505055] border min-w-[8rem]"
            >
              <button
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                }}
                className="px-4 py-1 rounded-md text-[#6D6D6D] text-fs_14 w-full flex items-center gap-2 hover:bg-slate-100"
              >
                <img
                  src={logoutIcon}
                  alt=":"
                  width={18}
                  height={18}
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="cursor-pointer"
                />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
